module.exports = __webpack_public_path__ + "media/dogs/dogs-eating-habits-3469bf61.svg";